import {
  HiOutlineDocumentArrowUp,
  HiOutlineMagnifyingGlass,
} from "react-icons/hi2";

import "./ExcelUploadCard.css";

export default function ExcelUploadCard({
  schoolYears = [],
  selectedSchoolYear,
  onSelectSchoolYear,
  file,
  onFileChange,
  isAnalyzing,
  onAnalyze,
}) {
  const canAnalyze = !!selectedSchoolYear?._id && !!file && !isAnalyzing;

  return (
    <section className="excel-upload-card">
      <div className="excel-upload-card__header">
        <div className="excel-upload-card__icon">
          <HiOutlineDocumentArrowUp />
        </div>

        <div>
          <h2>Excel analyseren</h2>
          <p>Selecteer een schooljaar en upload een Excel-bestand.</p>
        </div>
      </div>

      <div className="excel-upload-card__grid">
        <div className="excel-upload-card__group">
          <label>Schooljaar</label>

          <select
            value={selectedSchoolYear?._id || ""}
            onChange={(event) => onSelectSchoolYear(event.target.value)}
            disabled={isAnalyzing}
          >
            <option value="">Selecteer schooljaar</option>

            {schoolYears.map((schoolYear) => (
              <option key={schoolYear._id} value={schoolYear._id}>
                {schoolYear.name}
                {schoolYear.is_active ? " — actief" : ""}
              </option>
            ))}
          </select>
        </div>

        <div className="excel-upload-card__group">
          <label>Excel-bestand</label>

          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            disabled={isAnalyzing}
            onChange={(event) => onFileChange(event.target.files?.[0] || null)}
          />

          {file && <small>{file.name}</small>}
        </div>
      </div>

      <button
        type="button"
        className="excel-upload-card__button"
        disabled={!canAnalyze}
        onClick={onAnalyze}
      >
        <HiOutlineMagnifyingGlass />
        <span>{isAnalyzing ? "Analyseren..." : "Analyseer Excel"}</span>
      </button>
    </section>
  );
}
